import { render, staticRenderFns } from "./EmailsTable.vue?vue&type=template&id=bd357d86&"
import script from "./EmailsTable.vue?vue&type=script&lang=js&"
export * from "./EmailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports